module.exports = __webpack_public_path__ + "img/max-file-edit--excel.d0b426fa.svg";